/*
 * Public API Surface of fleet
 */

export * from './delete-configuration-profiles';
export * from './delete-driver-groups';
export * from './delete-map-set';
export * from './delete-vehicle-group';
export * from './fleet-environment';
export * from './get-avoid-favor-sets';
export * from './get-avoid-favor-sets-id';
export * from './get-avoid-favor-sets-vehicle-groups';
export * from './get-company-map-set-settings';
export * from './get-configuration-profiles';
export * from './get-configuration-profiles-id';
export * from './get-configuration-profiles-vehicle-groups';
export * from './get-driver-groups';
export * from './get-driver-groups-drivers';
export * from './get-drivers';
export * from './get-map-set-settings';
export * from './get-map-sets';
export * from './get-map-sets-id';
export * from './get-map-sets-vehicle-groups';
export * from './get-mapsets-available-regions';
export * from './get-place-sets';
export * from './get-place-sets-vehicle-groups';
export * from './get-routing-profile-vehicle-groups';
export * from './get-vehicle-groups';
export * from './get-vehicle-groups-id';
export * from './get-vehicle-groups-routing-profiles';
export * from './get-vehicle-groups-vehicles';
export * from './get-vehicles';
export * from './post-avoid-favor-sets-vehicle-groups-combined-assignment';
export * from './post-configuration-profiles';
export * from './post-configuration-profiles-vehicle-groups-combined-assignment';
export * from './post-driver-groups';
export * from './post-driver-groups-drivers-assign';
export * from './post-driver-groups-drivers-unassign';
export * from './post-map-sets';
export * from './post-map-sets-vehicle-groups-assign';
export * from './post-map-sets-vehicle-groups-combined-assignment';
export * from './post-map-sets-vehicle-groups-unassign';
export * from './post-place-sets-vehicle-groups-combined-assignment';
export * from './post-routing-profile-vehicle-groups-assign';
export * from './post-routing-profile-vehicle-groups-unassign';
export * from './post-vehicle-groups';
export * from './post-vehicle-groups-routing-profiles-combined-assignment';
export * from './post-vehicle-groups-vehicles-combined-assignment';
export * from './post-web-authenticate';
export * from './put-avoid-favor-sets-default';
export * from './put-configuration-profiles';
export * from './put-configuration-profiles-default';
export * from './put-driver-groups';
export * from './put-map-sets';
export * from './put-mapsets-vehicle-groups-assignment';
export * from './put-place-sets-default';
export * from './put-vehicle-groups';
export * from './schemas/available-regions.schema';
export * from './schemas/configuration-profile-paged-collection.schema';
export * from './schemas/configuration-profile.schema';
export * from './schemas/custom-place.schema';
export * from './schemas/driver-group-paged-collection';
export * from './schemas/driver-groups.schema';
export * from './schemas/driver.schema';
export * from './schemas/fleet-jwt.schema';
export * from './schemas/full-region.schema';
export * from './schemas/major-region.schema';
export * from './schemas/map-region.schema';
export * from './schemas/map-set.schema';
export * from './schemas/region-details.schema';
export * from './schemas/route-modifier-paged-collection.schema';
export * from './schemas/route-modifier.schema';
export * from './schemas/vehicle-group-paged-collection.schema';
export * from './schemas/vehicle-group.schema';
export * from './schemas/vehicle-paged-collection.schema';
export * from './schemas/vehicle.schema';
